import { Alert, Button, Form, Input, Modal } from 'antd';

interface DecisionFormValues {
  reason?: string;
}

interface ManualPriceDecisionModalProps {
  decision: 'approve' | 'reject' | null;
  jobNumber: string;
  error: string | null;
  submitting: boolean;
  onCancel: () => void;
  onSubmit: (decision: 'approve' | 'reject', reason: string | undefined) => Promise<boolean>;
}

/** Approving may say why; rejecting must, because the clerk revises the price from the reason. */
export function ManualPriceDecisionModal({ decision, jobNumber, error, submitting, onCancel, onSubmit }: ManualPriceDecisionModalProps) {
  const [form] = Form.useForm<DecisionFormValues>();
  const isRejecting = decision === 'reject';

  async function submit(values: DecisionFormValues) {
    if (!decision) return;
    if (await onSubmit(decision, values.reason?.trim() || undefined)) form.resetFields();
  }

  return (
    <Modal
      open={decision !== null}
      title={isRejecting ? `Reject the price for ${jobNumber}` : `Approve the price for ${jobNumber}`}
      onCancel={onCancel}
      footer={null}
      destroyOnHidden
    >
      <Form<DecisionFormValues> form={form} layout="vertical" requiredMark={false} onFinish={submit} disabled={submitting}>
        {error && <Alert className="mb-4" type="error" showIcon title={error} />}
        <Form.Item
          name="reason"
          label={isRejecting ? 'Reason' : 'Reason (optional)'}
          rules={isRejecting ? [{ required: true, whitespace: true, message: 'Enter a reason' }] : []}
        >
          <Input.TextArea rows={3} maxLength={500} />
        </Form.Item>
        <Form.Item className="mb-0 flex justify-end">
          <Button type="primary" danger={isRejecting} htmlType="submit" loading={submitting}>
            {isRejecting ? 'Reject' : 'Approve'}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
